import { useIdToken } from 'react-firebase-hooks/auth';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { auth, dogfen, casgliad, tocynNeges, deviceId, cadwCofnod } from '../firebase';
import { query, where, orderBy, onSnapshot, serverTimestamp, getDoc } from "firebase/firestore";

import { useState, createContext, useContext, useEffect, useRef } from 'react';
import { useRouteLoaderData, useNavigate, useLocation } from 'react-router-dom';
import { RootContext} from '../routes/root';
import Prysur from '../darnau/Prysur';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { gallu } from '../cyffredinol';

export const BYW = process.env.NODE_ENV !== 'development';
// export const LLEOL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const AppContext = createContext();

export const locales = {
	cy: "Cymraeg",
	en: "English",
};
export const defaultLocale = "cy";

export async function dynamicActivate(locale) {
	if (!locale) {
		try {
			locale = localStorage.getItem('iaith');
		} catch (e) { }
	}
	locale = locales[locale] ? locale : defaultLocale;
	const {messages} = await import(`../locales/${locale}/messages`);
	i18n.load(locale, messages);
	i18n.activate(locale);
	document.documentElement.lang = locale;
	try {
		localStorage.setItem('iaith', locale);
	} catch (e) { }
	return locale;
}

export function ApCefn({children}) {

	const fersiwn = useRef(null);
	const navigate = useNavigate();
	const location = useLocation();
	const [ap, apLoading] = useDocumentData( dogfen('cyffredinol', 'ap') );
	const [rolau, setRolauState] = useState();
	const [locale, setLocale] = useState(() => {
		return dynamicActivate(location?.state?.lang);
	});

	function setRolau(rolau) {
		if (Array.isArray(rolau)) {
			setRolauState(new Set(rolau));
		} else if (typeof rolau === 'string') {
			setRolauState(new Set([rolau]));
		} else {
			setRolauState(null);
		}
	}

	useEffect(() => {
		if (!apLoading && ap) {
			fersiwn.current = ap.cynhyrchu;
		}
	}, [apLoading]);

	useEffect(() => {
		if (ap?.cynhyrchu?.fersiwn && fersiwn.current.fersiwn !== ap.cynhyrchu.fersiwn) {
			window.location.reload();
		}
	}, [location]);

	const [user, userLoading] = useIdToken(auth, {onUserChanged: async user => {
		const token = await user.getIdTokenResult();
		if (!token.claims?.cynhyrchu) {
			setRolau(null);
			return;
		}
		const userData = {
			ebost: user.email,
			// mewngofnod: serverTimestamp(),
		};
		if (window.Notification?.permission === 'granted') {
			// cofnodiTocyn();
			const tocyn = await tocynNeges();
			if (tocyn) {
				userData[`dyfeisiau.${deviceId}`] = { tocyn, pryd: serverTimestamp() };
			}
		}
		const gwirioAmser = false;
		if (gwirioAmser) {
			const docRef = await cadwCofnod('cyfrifon', user.uid, userData, true);
			const docSnap = await getDoc(docRef);
			const secondsOut = 600; // 10 min
			const serverEpoch = docSnap.get('meta.newidiwyd.pryd')?.seconds;
			const localEpoch = Math.round(Date.now()/1000);
	// console.debug(serverEpoch, localEpoch, serverEpoch - localEpoch, secondsOut);
			if (localEpoch < serverEpoch - secondsOut || localEpoch > serverEpoch + secondsOut) {
				alert("Mae cloc dy gyfriadur yn anghywir. Fydd di ddim yn gallu newid unrhyw beth tan i ti gywiro hyn. Hola i Iwan os am gymorth.");
				setRolau('darllen');
				return;
			}
		} else {
			const offset = +(new Date()).getTimezoneOffset();
			if ( ![0, -60].includes(offset) && gallu(rolau, ['staff', 'bbc']) ) {
				alert("Mae cloc dy gyfrifiadur yn anghywir. Fydd di ddim yn gallu newid unrhyw beth tan i ti gywiro hyn. Hola i Iwan os am gymorth.");
				setRolau('darllen');
				return;
			}
		}
		setRolau(token.claims?.rolau);
	}});

	if (apLoading || userLoading) {
		return (
			<div className={'position-absolute top-50 start-50 translate-middle'}>
				<Prysur/>
			</div>
		);
	}

	if (!user || rolau === false) {
		navigate('/mewngofnodi');
	}

	// const ref = useRef({rolau:[], hysbysiadau, setHysbysiadau});
	// ref.current.creuHysbysiad = function(testun, math) {
	// 	ref.current.hysbysiadau = [...hysbysiadau, {testun, math, key:+new Date()}];
	// 	setHysbysiadau(ref.current.hysbysiadau);
	// }

	// function mapORestr(rhestr) {
	// 	return Object.fromEntries( rhestr.map(eitem => [eitem.id, eitem.enw]) );
	// }
	//return <Root/>;
	const context = {user, rolau, setRolau, mathauSlot, mathauCystadlu, swyddogaethau, ap, fersiwn};
	return (
		<AppContext.Provider value={context}>
			<I18nProvider i18n={i18n}>
				{children}
			</I18nProvider>
		</AppContext.Provider>
	);

}

export function useRolau(gwirio) {
	const {rolau} = useContext(AppContext);
	if (gwirio) {
		return gallu(rolau, gwirio);
	}
	return rolau;
}

export function useGolygu(dangos) {
	const {rolau} = useContext(AppContext);
	let angenRol;
	if (dangos === 'cyhoeddus') {
		angenRol = 'cyhoeddi';
	} else if (dangos === 'golygwyd') {
		angenRol = 'golygydd';
	} else {
		angenRol = 'staff';
	}
	return gallu(rolau, angenRol);
}

export function useAp() {
	const {ap} = useContext(AppContext);
	return ap || null;
}

export function useCyfrif() {
	const {user} = useContext(AppContext);
	return user || null;
}

export function useBlwyddyn() {
	const blwyddyn = useRouteLoaderData('blwyddyn');
	return blwyddyn || 2099;
}

export function useAdrannau() {
	const { blwyddyn } = useContext(RootContext);
	return useCasgliad('adrannau', [
		casgliad(`${blwyddyn}/cynhyrchu/adrannau`),
		orderBy('trefn', 'asc')
	]);
}

export function useCyllidebau() {
	const { blwyddyn } = useContext(RootContext);
	return useCasgliad('cyllidebau', [
		casgliad(`${blwyddyn}/preifat/cyllidebau`),
		orderBy('enw', 'asc')
	]);
}

export function useCystadlaethau() {
	const { blwyddyn } = useContext(RootContext);
	return useCasgliad('cystadlaethau', [
		casgliad(`${blwyddyn}/cynhyrchu/cystadlaethau`),
		//where('dangos', 'in', ['barod', 'golygwyd', 'cyhoeddus']),
		orderBy('rhif', 'asc')
	]);
}

export function useLlefydd() {
	const { blwyddyn } = useContext(RootContext);
	return useCasgliad('llefydd', [
		casgliad(`${blwyddyn}/cynhyrchu/llefydd`),
		where('dangos', 'in', ['cuddio', 'barod', 'golygwyd', 'cyhoeddus']),
		orderBy('trefn', 'asc')
	]);
}

export function usePrisiau(math) {
	const { blwyddyn } = useContext(RootContext);
	const amodau = [
		casgliad(`${blwyddyn}/preifat/prisiau`),
		orderBy('enw', 'asc')
	];
	if (math === 'cystadlu') {
		amodau.push(where('math', 'in', ['llwyfan', 'cyfansoddi', 'arall', 'celf']))
	} else if (math) {
		amodau.push(where('math', '==', math))
	}
	return useCasgliad('prisiau', amodau);
}

function useCasgliad(enw, amodau) {
	const context = useContext(RootContext);

	if (context[enw] === null) {
		const setData = context['set' + enw.charAt(0).toUpperCase() + enw.slice(1)];
		context[enw] = false;//setData(false); // osgoi ail-lwytho

		const unsubscribe = onSnapshot(query(...amodau), docs => {
			const data = [];
			docs.forEach(doc => data.push(doc.data()));
			setData(data);
			console.debug(`Llwythwyd ${enw}`, data);
		}, error => {
			console.debug(`Methwyd llwytho ${enw}`, error);
		});
		context.storfa.current.listeners[enw] = () => {
			unsubscribe();
			setData(null);
		};
	}
	return context[enw] || [];
}

export function useNodwedd(nodwedd) {
	const blwyddyn = useRouteLoaderData('blwyddyn');
	const {ap} = useContext(AppContext);
	return ( blwyddyn && ap && (
		ap.cynhyrchu?.nodweddion?.[nodwedd]?.includes(blwyddyn)
		|| ap.nodweddion?.[nodwedd]?.includes(blwyddyn)
	) ) ? true : false;
}

/*
export const mathauSlot = [
	{id: "cabaret", enw: "Cwt Cabaret", enw_en: "Cabaret"},
	{id: "celf", enw: "Celf a chrefft", enw_en: "Arts and crafts"},
	{id: "cerdd", enw: "Cerddoriaeth", enw_en: "Music"},
	{id: "chwaraeon", enw: "Chwaraeon a hamdden", enw_en: "Sports and leisure"},
	{id: "comedi", enw: "Comedi", enw_en: "Comedy"},
	{id: "cyngerdd", enw: "Cyngherddau", enw_en: "Concerts"},
	{id: "dawns", enw: "Dawns", enw_en: "Dance"},
	{id: "drama", enw: "Drama", enw_en: "Drama"},
	{id: "dysgu", enw: "Dysgu Cymraeg", enw_en: "Learning Welsh"},
	{id: "llen", enw: "Llenyddiaeth", enw_en: "Literature"},
	{id: "mas", enw: "Mas ar y Maes", enw_en: "Mas ar y Maes"},
	{id: "plant", enw: "Plant a theulu", enw_en: "Family and children"},
	{id: "seremoni", enw: "Seremonïau", enw_en: "Ceremonies"},
	{id: "sgwrs", enw: "Sgyrsiau, gweithdai, cyfarfodydd", enw_en: "Talks, workshops, meetings"},
	{id: "syrcas", enw: "Theatr stryd a syrcas", enw_en: "Street theatre and circus"},
];
*/

export const mathauSlot = new Map([
	[ "cabaret", { enw: "Cwt Cabaret", enw_en: "Cabaret" } ],
	[ "celf", { enw: "Celf a chrefft", enw_en: "Arts and crafts" } ],
	[ "cerdd", { enw: "Cerddoriaeth", enw_en: "Music" } ],
	[ "chwaraeon", { enw: "Chwaraeon a hamdden", enw_en: "Sports and leisure" } ],
	[ "comedi", { enw: "Comedi", enw_en: "Comedy" } ],
	[ "cyngerdd", { enw: "Cyngherddau", enw_en: "Concerts" } ],
	[ "dawns", { enw: "Dawns", enw_en: "Dance" } ],
	[ "drama", { enw: "Drama", enw_en: "Drama" } ],
	[ "dysgu", { enw: "Dysgu Cymraeg", enw_en: "Learning Welsh" } ],
	[ "llen", { enw: "Llenyddiaeth", enw_en: "Literature" } ],
	[ "mas", { enw: "Mas ar y Maes", enw_en: "Mas ar y Maes" } ],
	[ "plant", { enw: "Plant a theulu", enw_en: "Family and children" } ],
	[ "seremoni", { enw: "Seremonïau", enw_en: "Ceremonies" } ],
	[ "sgwrs", { enw: "Sgyrsiau, gweithdai, cyfarfodydd", enw_en: "Talks, workshops, meetings" } ],
	[ "syrcas", { enw: "Theatr stryd a syrcas", enw_en: "Street theatre and circus" } ],
]);

export const mathauCystadlu = new Map([
	[ "ymarfer", { enw:"Ymarfer", enw_en:"Rehearsal" } ],
	[ "rhagwrandawiad", { enw:"Rhagwrandawiad", enw_en:"Pre-hearing" } ],
	[ "cynderfynol", { enw:"Rownd cynderfynol", enw_en:"Semi final" } ],
	[ "perfformiad", { enw:"Perfformiad", enw_en:"Performance" } ],
	[ "cystadlu", { enw:"Rownd derfynol", enw_en:"Final" } ],
	[ "beirniadaeth", { enw:"Beirniadaeth", enw_en:"Adjudication" } ],
	[ "canlyniad", { enw:"Canlyniad", enw_en:"Result" } ],
]);

export const swyddogaethau = new Map([
	[ "artist", {enw:"Artist"} ],
	[ "arweinydd", {enw:"Arweinydd"} ],
	[ "beirniad", {enw:"Beirniad"} ],
	[ "cyfeilydd", {enw:"Cyfeilydd"} ],
	[ "datgeinydd", {enw:"Datgeinydd"} ],
	[ "trefnydd", {enw:"Trefnydd"} ],
	[ "detholwr", {enw:"Detholwr"} ],
	[ "gweinyddwr", {enw:"Gweinyddwr"} ],
	[ "cyfrannwr", {enw:"Cyfrannwr"} ],
	[ "rheolwr", {enw:"Rheolwr"} ],
	[ "aelod", {enw:"Aelod"} ],

	[ "act", {enw:"Act"} ],
	[ "trefnwyr", {enw:"Trefnwyr"} ],
]);

export const mathauPoblAct = new Set(['artist', 'rheolwr', 'aelod']);
export const mathauPoblCystadleuaeth = new Set(['beirniad', 'cyfeilydd', 'datgeinydd', 'detholwr', 'gweinyddwr']);
export const cytundebauAct = [
	{id:"buy-out", enw: "Buy out"},
	{id:"dim-darlledu", enw: "Dim darlledu"},
	{id:"theatr", enw: "Theatr"},
	{id:"mu", enw: "Undeb y Cerddorion / MU"},
	{id:"writers", enw: "Undeb yr Ysgrifenwyr / Writer’s Guild"},
];
// export const cytundebauCystadleuaeth = new Set(['beirniadu']);

export const projectau = new Map([
	[ "beirniadu", { enw: "Beirniadu a chyfeilio" } ],
]);
export const gwyliau = new Map([
	[ 2026, { enw: "Eisteddfod y Garreg Las", lleoliad: "Sir Benfro" } ],
]);

export const PRIF_WOBRAU = [701, 702, 712, 713, 951];

// export const gwelededdCofnod = {
// 	dileu: "Dileu",
// 	cuddio: "Cuddio",
// 	drafft: "Drafft",
// 	barod: "Barod",
// 	golygwyd: "Golygwyd",
// 	cyhoeddus: "Cyhoeddus",
// };
